import { SessionConfig } from '../app/models/session-config.interface';

export const environment = {
  production: true,
  landingUrl: 'https://missionspecialtyconsults.stratocyte.com',
  cdnUrl: 'https://cdn.missionspecialtyconsults.stratocyte.com',
  assets:'./assets/',
  documentBaseUrl: '/api/user/files/',
  features: {
    paymentsEnabled: false,
    stripeEnabled: false,
    specialtyIntakeEnabled: true,
    theme: 'mission',
  },
  session: {
    enabled: true,
    idleTimeoutMinutes: 120,
    absoluteTimeoutHours: 12,
    rememberMeTimeoutDays: 30,
    warningBeforeTimeoutMinutes: 2
  } as SessionConfig,
  stripe: {
    publishableKey: '',
  },
  pusher: {
    key: '55af4d4893da8cf82020',
    cluster: 'mt1',
    authEndpoint: '/api/specialist/chat/pusher/auth'
  },
  zoom: {
    sdkKey: 'VnSX_6i7R3W5P4b4ei46nQ'
  }
};
